var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMiconTypeAuto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m28.316 13.949-.632-1.898L17 15.612V4h-2v11.612L4.316 12.051l-.632 1.898 10.684 3.561L7.2 27.066l1.6 1.201 7.2-9.6 7.2 9.6 1.6-1.201-7.168-9.556z"
})));
export default SvgMiconTypeAuto;